import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { useEffect, useMemo, useState } from "react";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
const EditSurvey = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { accessToken, userData } = useSelector(state => state.user);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id
    });
    const [surveyData, setSurveyData] = useState({}); 
    const [deletedFieldIds,setDeletedFieldIds] = useState([]);
    useEffect(() => {
        if (!location.state?.survey_id || location.state?.survey_id < 1) {
            navigate('/survey');
        }
        else{
            dispatch(setPageTitle('Edit Survey'));
            let promiseArray = [];
            if (userData.role_slug === "super_admin") {
                promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
            }
            if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
            }
            if (promiseArray.length > 0) {
                dispatch(setMainLoading(true));
                Promise.all(promiseArray)
                    .then((response) => {
                        if (response[0].config.url === "masters/organization") {
                            if (response[0].data.status === "1") {
                                setOrgList(response[0].data.data);
                            }
                        }
                        else {
                            if (response[0].data.status === "1") {
    
                                setDivList(response[0].data.data);
                            }
                        }
                        if (response?.[1]?.config?.url === "masters/division-list") {
                            if (response[1].data.status === "1") {
                                setDivList(response[1].data.data);
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    }).finally(() => {
                        dispatch(setMainLoading(false));
                    })
            }
        }
    }, [accessToken, dispatch, userData]);
    const divListForSelect2 = useMemo(() => {
        if (parseInt(filter.org_id) > 0) {
            let tempDivList = [];
            if (divList.length > 0) {
                for (let ml of divList) {
                    if (parseInt(ml.org_id) === parseInt(filter.org_id)) {
                        tempDivList.push({ value: ml.ID, label: `${ml.division_name} ${`(${ml.division_number})`}` })
                    }
                }
                return tempDivList;
            }
        }
        return [];
    }, [filter.org_id]);
    useEffect(() => {
        if(divList.length > 0){
            getSurveyData();
        }
    },[divList])
    const MyCheckbox = ({ field, form, label, ...rest }) => {
        const { name, value: formikValue } = field;
        const { setFieldValue } = form;
        const handleChange = event => {
            const values = formikValue;
            setFieldValue(name, values === 0 ? 1 : 0);
        };
        return (
            <label className="container-checkbox">
                <input
                    type="checkbox"
                    onChange={handleChange}
                    checked={parseInt(formikValue) === 1}
                    {...rest}
                />
                <span className="checkmark"></span>
                {label}
            </label>
        );
    };
    const getSurveyData = () => {
        dispatch(setMainLoading(true));
        PostAxios(`survey/survey-details`, { survey_id: location.state.survey_id }, accessToken)
            .then(({data}) => {
                if (data.status === "1") {
                    setFilter({ ...filter, org_id: data.data.form_data.org_id });
                    let divArray = data.data.form_data.user_div.split(',').map(i => parseInt(i));
                    let userDiv = [];
                    for(let i of divList){
                        if(divArray.indexOf(parseInt(i.ID)) > -1){
                            userDiv.push({ value: i.ID, label: `${i.division_name} ${`(${i.division_number})`}` });
                        }
                    }
                    setSurveyData({...data.data.form_data,user_div:userDiv,questions:data.data.form_fields});
                }
                else {
                    dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    if (typeof surveyData.title !== "undefined") {
        return (
            <div className="main-form-sec">
                <Formik
                    initialValues={{
                        org_id: parseInt(surveyData.org_id) > 0 ? parseInt(surveyData.org_id) : 0,
                        div_id: [...surveyData.user_div],
                        title: surveyData.title,
                        description: surveyData.description,
                        questions: [...surveyData.questions],
                        valid_from: moment(surveyData.valid_from).format('yyyy-MM-DD'),
                        valid_until: moment(surveyData.valid_until).format('yyyy-MM-DD')
                    }}
                    validate={values => {
                        const errors = {};
                        if (parseInt(values.org_id) < 1) { errors.org_id = "Organization ID should not be empty"; }
                        if (values.div_id.length < 1) { errors.div_id = "Organization ID should not be empty"; }
                        if (!values.questions || !values.questions.length) {
                            errors.questions = [{ label: 'Label is Required', type: 'Question Type is required' }];
                        }
                        else {
                            errors.questions = values.questions.map((item) => ({
                                label: item.label ? '' : 'Label is required',
                                type: item.type ? '' : 'Question Type is required',
                                options: (item.type === "radio" || item.type === "checkbox") && item.options === "" ? "Options is required" : ""
                            }));
                        }
                        const hasErrors = Object.values(errors.questions).some((itemErrors) => Object.values(itemErrors).some((error) => !!error));
                        if (hasErrors === false) delete errors.questions;
                        if (!values.title) { errors.title = "Survey Title should not be empty"; }
                        if (!values.valid_from) { errors.valid_from = "Please choose Survey start date"; }
                        if (!values.valid_until) { errors.valid_until = "Please choose Survey end date"; }
                        if (!values.description) { errors.description = "Please choose Survey description"; }
                        return errors;
                    }}
                    onSubmit={(values,{setSubmitting,resetForm})=>{
                        dispatch(setMainLoading(true));
                        setSubmitting(true);
                        let tempVals = [];
                            for(let sc of values.div_id){
                                tempVals.push(sc.value);
                            }
                        let div_id = tempVals.join(',');
                        PostAxios(`survey/update-survey`,{
                            org_id: values.org_id,
                            div_id: div_id,
                            title: values.title,
                            description: values.description,
                            questions: values.questions,
                            valid_from: values.valid_from,
                            valid_until: values.valid_until,
                            survey_id: location.state.survey_id,
                            deleted_field_ids: deletedFieldIds
                        },accessToken)
                        .then(({data})=>{
                            if (data.status === "1") {
                                dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                                resetForm();
                                navigate('/survey');
                            }
                            else {
                                dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                            }
                            setSubmitting(false);
                            dispatch(setMainLoading(false));
                        })
                        .catch((err)=>{
                            responseCatchFunc(dispatch,err);
                            setSubmitting(false);
                            dispatch(setMainLoading(false));
                        })
                    }}
                    enableReinitialize
                >
                    {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                        <Form>
                            <div className="form-sec">
                                {
                                    userData.role_slug === "super_admin" &&
                                    <div className={`form-field-group w-50 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="org_id">Organization*</label>
                                        </div>
                                        <div className="w-50">
                                            <label className="select-input-outer select-100">
                                                <Field name="org_id" as="select" className="select-input" onChange={(e) => {
                                                    if (e.target.value === "0") {
                                                        setFieldValue('div_id', 0);
                                                    }
                                                    setFilter({ org_id: e.target.value })
                                                    handleChange(e)
                                                }}>
                                                    <option value="0">Choose Organization</option>
                                                    {
                                                        orgList.length > 0 && orgList.map((item, index) => {
                                                            return <option value={item.ID} key={`org-list-${item.ID}`}>{item.short_name}</option>
                                                        })
                                                    }
                                                </Field>
                                            </label>
                                            <ErrorMessage component="span" name="org_id" className="error-label" />
                                        </div>
                                    </div>
                                }
                                {
                                    (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                    <div className={`form-field-group w-50 ${(errors.div_id && touched.div_id) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="div_id">Mohallah*</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={[{ label: 'Select All', value: 'select_all' }, ...divListForSelect2]}
                                                placeholder="Choose Mohallah"
                                                value={values.div_id}
                                                onChange={async (selectedValues) => {
                                                    if (selectedValues.some((option) => option.value === 'select_all')) {
                                                        setFieldValue(`div_id`, divListForSelect2);
                                                    } else {
                                                        setFieldValue(`div_id`, selectedValues);
                                                    }
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                            <ErrorMessage component="span" name="div_id" className="error-label" />
                                        </div>
                                    </div>
                                }
                                <div className={`form-field-group w-50 ${(errors.title && touched.title) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="title">Title*</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field type="text" className="form-input" placeholder="Survey Title" name='title' />
                                        <ErrorMessage component="span" name="title" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.description && touched.description) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="description">Description</label>
                                    </div>
                                    <div className="w-50 input-area">
                                        <Field as="textarea" className="form-input form-textarea" placeholder="Description" name='description' rows={5} />
                                        <ErrorMessage component="span" name="description" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.valid_from && touched.valid_from) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="valid_from">Survey Start Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Start Date"
                                                name={`valid_from`}
                                                id={`valid_from`}
                                                clearIcon={null}
                                                minDate={new Date()}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`valid_from`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.valid_from && new Date(values.valid_from)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="valid_from" className="error-label" />
                                    </div>
                                </div>
                                <div className={`form-field-group w-50 ${(errors.valid_until && touched.valid_until) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="valid_until">Survey End Date*</label>
                                    </div>
                                    <div className="w-50">
                                        <div className="date-picker-sec">
                                            <DatePicker
                                                className="form-input"
                                                placeholder="Start Date"
                                                name={`valid_until`}
                                                id={`valid_until`}
                                                clearIcon={null}
                                                minDate={new Date(values.valid_from)}
                                                format="dd-MM-y"
                                                dayPlaceholder="DD"
                                                monthPlaceholder="MM"
                                                yearPlaceholder="YYYY"
                                                onChange={(val) => {
                                                    if (val) {
                                                        setFieldValue(`valid_until`, moment(val).format("YYYY-MM-DD"))
                                                    }
                                                }}
                                                value={(values.valid_until && new Date(values.valid_until)) || null}
                                            />
                                        </div>
                                        <ErrorMessage component="span" name="valid_until" className="error-label" />
                                    </div>
                                </div>
                                <div className="divider"></div>
                                <FieldArray name="questions">
                                    {({ push, remove }) => (
                                        <div className={`location-impacted-main w-75`}>
                                            {values.questions.map((question, index) => (
                                                <div key={index} className="form-field-group w-100">
                                                    <div className={`location-impacted ${(errors.questions?.[index]?.label && errors.questions?.[index]?.label) ? 'error-input' : ''}`}>
                                                        <label htmlFor={`questions.${index}.label`}>Question Label*</label>
                                                        <Field type="text" className="form-input" name={`questions.${index}.label`} />
                                                        <ErrorMessage name={`questions.${index}.label`} component="span" className="error-label" />
                                                    </div>
                                                    <div className={`location-impacted ${(errors.questions?.[index]?.required && errors.questions?.[index]?.required) ? 'error-input' : ''}`}>
                                                        <label htmlFor={`questions.${index}.required`}>Is Required?</label>
                                                        <Field component={MyCheckbox} name={`questions.${index}.required`} label="" />
                                                        <ErrorMessage name={`questions.${index}.required`} component="span" className="error-label" />
                                                    </div>
                                                    <div className={`location-impacted ${(errors.questions?.[index]?.type && errors.questions?.[index]?.type) ? 'error-input' : ''}`}>
                                                        <label htmlFor={`questions.${index}.type`}>Type*</label>
                                                        <Field className="select-input" as="select" name={`questions.${index}.type`}>
                                                            <option value="text">Short Answer</option>
                                                            <option value="textarea">Big Answer</option>
                                                            <option value="radio">Single Choice</option>
                                                            <option value="checkbox">Multiple Choice</option>
                                                        </Field>
                                                        <ErrorMessage name={`questions.${index}.type`} component="span" className="error-label" />
                                                    </div>
    
                                                    <div className={`location-impacted ${(errors.questions?.[index]?.options && errors.questions?.[index]?.options) ? 'error-input' : ''}`}>
                                                        {(question.type === 'radio' || question.type === 'checkbox') && (
                                                            <>
                                                                <label htmlFor={`questions.${index}.options`}>Option <small>{`(Comma Saperated)`}</small></label>
                                                                <Field as="textarea" className="form-input" name={`questions.${index}.options`} style={{ minHeight: 70 }} placeholder="Option 1, Option 2" />
                                                                <ErrorMessage
                                                                    name={`questions.${index}.options`}
                                                                    component="span"
                                                                    className="error-label"
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="prc-action-btn">
                                                        {
                                                            (values.questions.length - 1) == index &&
                                                            <button type="button" className="add-icon" onClick={() => push({ label: '', type: 'text', options: '', required: 0,position: 0 })}>
                                                                <i className="fa-solid fa-circle-plus"></i>
                                                            </button>
                                                        }
                                                        {
                                                            values.questions.length > 1 &&
                                                            <button type="button" className="remove-icon" onClick={() => {
                                                                if(typeof values.questions[index].id !== 'undefined' && values.questions[index].id !== null){
                                                                    setDeletedFieldIds([...deletedFieldIds, values.questions[index].id])

                                                                }
                                                                remove(index);
                                                            }}>
                                                                <i className="fa-solid fa-circle-xmark"></i>
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </FieldArray>
                                <div className="btm-right-btn justify-content-center my-3">
                                    <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Update Survey</button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
    return null;
}

export default EditSurvey;